import { Separator } from '@carboncopyco/ui';

export const TableRowWrapper = ({
  children,
}: {
  children?: React.ReactNode;
}) => (
  <div className="flex flex-col">
    <div className="py-4">{children}</div>
    <Separator horizontal />
  </div>
);
